/* eslint-disable import/prefer-default-export */
import * as ics from 'ics';
import moment from 'moment';

const downloadReminder = (eventStart, eventEnd, eventTitle) => {
  const momentDateStart = moment(eventStart);
  const momentDateEnd = moment(eventEnd);

  const startEvent: ics.DateArray = [
    momentDateStart.year(),
    (momentDateStart.month() + 1),
    momentDateStart.date(),
    momentDateStart.hour(),
    momentDateStart.minute(),
  ];

  const endEvent: ics.DateArray = [
    momentDateEnd.year(),
    (momentDateEnd.month() + 1),
    momentDateEnd.date(),
    momentDateEnd.hour(),
    momentDateEnd.minute(),
  ];

  const reminderTime: ics.Alarm[] = [{
    action: 'display',
    trigger: {
      hours: 0,
      minutes: 3,
      before: true,
    },
  }];

  ics.createEvent({
    start: startEvent,
    end: endEvent,
    title: eventTitle,
    status: 'CONFIRMED',
    alarms: reminderTime,
    description: 'Reminder to Stockbit Event',
  }, (error, value) => {
    if (error) {
      console.log(error);
      return;
    }

    // write .ics file
    const blob = new Blob([value], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = 'stockbit_event.ics';
    link.href = url;
    link.click();
  });
};

export {
  downloadReminder,
};
